import { useQuery } from '@tanstack/react-query';

import { hasKey } from '~/utils';
import { config } from '~/config';
import { useRequest } from '~/lib/useRequest';
import {
  ApplicationAdmissionConditionResource,
  ListApplicationAdmissionConditionsResponse,
} from '@ab/ams-school-api/types/private/v1';

export type ApplicationAdmissionCondition = ApplicationAdmissionConditionResource['attributes'] & { id: string };

export function useApplicationAdmissionCondition() {
  const request = useRequest();

  const { isLoading, isFetching, error, data, isError } = useQuery({
    queryKey: ['application_admission_conditions'],
    queryFn: async () => {
      const response = await request<ListApplicationAdmissionConditionsResponse>(
        `${config.apiHost}/private/v1/admission_conditions?page[number]=1&page[size]=100`,
        {
          method: 'GET',
          isExpectedResponse,
        }
      );

      const conditions = response.data;
      return conditions.map((condition) => {
        return {
          id: condition.id,
          name: condition.attributes.name,
          code: condition.attributes.code,
        };
      });
    },
  });
  return {
    isLoadingAdmissionCondition: isLoading,
    isFetchingAdmissionCondition: isFetching,
    admissionConditionError: error,
    admissionConditions: data,
    isAdmissionConditionError: isError,
  };
}

function isExpectedResponse(res: unknown): res is ListApplicationAdmissionConditionsResponse {
  return Boolean(res && typeof res === 'object' && hasKey('data', res));
}
